import { forwardRef } from "react";

const GraphicContainer = forwardRef(({ children, height = 300 }, ref) => {
  return (
    <div ref={ref} style={{ margin: "20px auto", width: "100%", maxWidth: "860px", height }}>
      {children}
    </div>
  );
});

export default GraphicContainer;
